if (typeof BeforeAfter !== "function") {
  class BeforeAfter extends HTMLElement {
    constructor() {
      super();

      this.container = this.querySelector(".before-after");
      this.slider = this.querySelector(".before-after__slider");

      // Transición para cambios manuales (opcional)
      this.container.style.transition = "all 600ms ease";

      this.slider.addEventListener("input", (e) => {
        this.container.style.setProperty('--position', `${e.target.value}%`);
      });

      this.slider.addEventListener("change", (e) => {
        this.container.style.setProperty('--position', `${e.target.value}%`);
      });

      // Observer para detectar cuando el bloque es visible y disparar la animación una sola vez
      this.hasAnimated = false;
      this.createObserver();

      if (this.classList.contains('invert-layout')) {
        this.originalLayout = this.dataset.layout;
        this.RESIZE_WATCHER = debounce(() => {
          const afterContent = window.getComputedStyle(this, ':after').content;
          if (afterContent.includes('invert-layout') && this.dataset.layout === this.originalLayout) {
            this.invertLayout();
          } else if (!afterContent.includes('invert-layout') && this.dataset.layout !== this.originalLayout) {
            this.invertLayout();
          }
        }, 100);
        window.addEventListener('resize', this.RESIZE_WATCHER);
        this.RESIZE_WATCHER();
      }
    }

    createObserver() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this.hasAnimated) {
            this.animateSlider();
            this.hasAnimated = true;
          }
        });
      }, { threshold: 0.5 });
      observer.observe(this);
    }

      animateSlider() {
        const centerValue = 50;
        // Aseguramos que el slider y la variable CSS inicien en el centro
        this.slider.value = centerValue;
        this.container.style.setProperty('--position', `${centerValue}%`);
      
        // Aplicamos la animación con una duración total de 1.5s
        this.container.style.animation = "sliderAnimation 1.5s ease-in-out forwards";
      
        // Al finalizar, se elimina la animación para no interferir con la interacción manual
        this.container.addEventListener("animationend", () => {
          this.container.style.animation = "";
        }, { once: true });
      }


    invertLayout() {
      this.dataset.layout = this.dataset.layout === 'vertical' ? 'horizontal' : 'vertical';
      this.setAttribute('data-layout', this.dataset.layout);
      this.querySelector('input[type="range"]').setAttribute('orient', this.dataset.layout);
    }
  }

  if (typeof customElements.get("before-after") == "undefined") {
    customElements.define("before-after", BeforeAfter);
  }
}
